import { useEffect } from "react";
import { useSelector } from "react-redux";
import { READY_MODULE_EVENTS } from "./constants";
import { selectStudentPreChecks } from "./studentPreChecksSlice";
import useStudentPreChecks from "./useStudentPreChecks";

export default function useWindowEvents() {

    const studentPreChecks = useSelector(selectStudentPreChecks);

    const studentPreCheck = useStudentPreChecks({ itemToCheck: studentPreChecks.currentCheck });

    useEffect(()=>{
        const visibilityHandler = ()=>{
            if (document.hidden){
                studentPreCheck.logEvent(READY_MODULE_EVENTS.WINDOW_TAB_HIDDEN, studentPreChecks.currentCheck)
            }else {
                studentPreCheck.logEvent(READY_MODULE_EVENTS.WINDOW_TAB_RESUMED, studentPreChecks.currentCheck)
            }
        }
        window.addEventListener('visibilitychange', visibilityHandler)

        return () => {
            window.removeEventListener('visibilitychange', visibilityHandler)
        }

    }, [])
}
